<!--
 * @Author: your name
 * @Date: 2021-09-09 10:46:29
 * @LastEditTime: 2021-09-09 17:01:18
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \taotan_admin\src\views\marriageGetName\sinologyNav\index.vue
-->
<template>
  <section>
    <div class="role">
      <div class="roleRight">
        <!-- S 筛选条件 -->
        <div class="roleRight_Top">
          <template v-if="searchShow">
            <el-input
                clearable
                v-model="search.searchKey"
                clas="input_search"
                placeholder="搜索关键字"
                @keyup.enter.native="SearchEvaluationList"
            ></el-input>
            <el-select v-model="search.status" clearable placeholder="请选择">
              <el-option
                  v-for="item in COMMON_STATUS"
                  :key="item.key"
                  :label="item.name"
                  :value="item.key"
              ></el-option>
            </el-select>
            <el-button size="medium" type="primary" @click="SearchEvaluationList"
            >查询</el-button
            >
          </template>

          <el-button
              v-if="addShow"
            size="medium"
            type="primary"
            @click="handleClick('addNext')"
            >新增</el-button
          >
        </div>
        <!-- E 筛选条件 -->
        <!-- S 表格 -->

        <div class="roleRight_Container public-table-data">
          <el-table
            v-loading="loading"
            :data="tableData"
            size="medium"
            border
            style="width: 100%"
          >
            <el-table-column fixed label="序号" type="index" width="100">
              <template slot-scope="scope">
                <span>{{
                  (page.pageNo - 1) * page.pageSize + scope.$index + 1
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="icon" label="ICON">
              <template slot-scope="scope">
                <el-image
                  v-if="scope.row.icon"
                  style="width: 50px; height: 50px"
                  :src="scope.row.icon"
                  fit="cover"
                ></el-image>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="名称"> </el-table-column>
            <el-table-column prop="descr" label="说明"> </el-table-column>
            <el-table-column prop="color" label="文字颜色" min-width="160">
              <template slot-scope="scope">
                <!-- <el-color-picker disabled v-model="scope.row.color"></el-color-picker> -->

                <div
                  class="color-width"
                  :style="{ backgroundColor: scope.row.color }"
                ></div>
              </template>
            </el-table-column>
            <el-table-column prop="seq" label="序号"> </el-table-column>
            <el-table-column prop="status" label="状态" min-width="80">
              <template slot-scope="scope">
                <el-switch
                    :disabled="statusShow"
                  v-model="scope.row.status"
                  :active-value="1"
                  :inactive-value="0"
                  @change="handleSwitch(scope.$index)"
                ></el-switch>
              </template>
            </el-table-column>

            <el-table-column fixed="right" label="操作" min-width="180">
              <template slot-scope="scope">
                <el-button
                  @click="handleClick('change', scope.row)"
                  plain
                  size="small"
                  v-if="editShow"
                  >修改</el-button
                >
                <!-- <el-button
                  type="primary"
                  plain
                  size="small"
                  @click="del(scope.row)"
                  >删除</el-button
                > -->
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="roleRight_pagenation">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.pageNo"
            :page-sizes="[PAGE_SIZE, 15, 20, 25]"
            :page-size="page.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.count"
          >
          </el-pagination>
        </div>
        <!-- E 表格 -->
      </div>
    </div>

    <!-- 编辑弹框 -->
    <el-dialog
      :title="
        clickType == 'change'
          ? '修改导航'
          : clickType == 'addNext'
          ? '新增导航'
          : ' 其他 '
      "
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="480px"
      class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
          ref="ruleForm"
          :rules="rules"
          :model="params"
          label-width="80px"
        >
          <el-form-item
            label="ICON"
            class="item"
            v-if="clickType == 'change' || clickType == 'addNext'"
          >
            <el-col :span="12">
              <!--图片部分-->
              <div class="screenshot">
                <span
                  v-for="(imgUrl, index) in srcList"
                  :key="index"
                  class="slideshow"
                >
                  <div
                    class="icon-close"
                    @click="removeUploading(index)"
                    v-if="isMoer"
                  >
                    <i class="el-icon-close"></i>
                  </div>
                  <el-image
                    style="width: 58px; height: 58px; border-radius: 6px"
                    :src="imgUrl"
                    fit="cover"
                    @click="getPolicy"
                  />
                </span>
                <div
                  v-loading="loading1"
                  class="up-btn"
                  style="width: 58px; height: 58px; line-height: 66px;display:block;"
                  @click="getPolicy"
                  v-if="isMoer"
                >
                  <i class="el-icon-plus"></i>
                </div>
              </div>
              <input type="file" ref="file" @change="getFile" />
            </el-col>
            <el-col :span="12">
              <el-form-item label="颜色">
                <el-color-picker v-model="params.color"></el-color-picker>
              </el-form-item>
            </el-col>
          </el-form-item>

          <!-- <el-form-item
            label="背景图"
            v-if="clickType == 'change' || clickType == 'addNext'"
          >
            <div>
              <div class="diplay" style="margin-right: 10px">
                <div class="screenshot">
                  <span
                    v-for="(imgUrl, index) in srcListBg"
                    :key="index"
                    class="slideshow"
                  >
                    <div class="icon-close" @click="removeUploading(index)">
                      <i class="el-icon-close"></i>
                    </div>
                    <el-image
                      style="width: 175px; height: 75px; border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"
                      @click="getPolicyBg"
                    />
                  </span>
                  <div
                    class="up-btn"
                    style="width: 175px; height: 75px; line-height: 80px"
                    @click="getPolicyBg"
                    v-loading="loading2"
                    v-if="isMoerBg"
                  >
                    <i class="el-icon-plus"></i>
                  </div>
                </div>
                <input
                  type="file"
                  ref="fileBg"
                  @change="getfileBg()"
                  accept="image/png,image/jpg"
                />
              </div>
            </div>
          </el-form-item> -->

          <el-row v-if="clickType == 'change' || clickType == 'addNext'">
            <el-col :span="14">
              <el-form-item label="名称" prop="name">
                <el-input
                  clearable
                  placeholder="导航名称"
                  v-model="params.name"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12"> </el-col>
          </el-row>

          <el-row v-if="clickType == 'change' || clickType == 'addNext'">
            <el-col :span="22">
              <el-form-item label="说明">
                <el-input
                  type="textarea"
                  :rows="4"
                  maxlength="200"
                  placeholder="最长为200个字符"
                  v-model="params.descr"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="序号" prop="seq">
                <el-input
                  clearable
                  placeholder="序号为数字"
                  v-model.number="params.seq"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button
          size="medium"
          @click="dialogVisible = false"
          v-if="clickType != 'right'"
          >取 消</el-button
        >
        <el-button
          size="medium"
          type="primary"
          @click="handleEdit"
          v-if="clickType != 'right'"
          >提 交</el-button
        >
      </span>
    </el-dialog>
  </section>
</template>
<script>
import { PAGE_SIZE, COMMON_STATUS } from "@/config";
import { isEmpty } from "@utils/tools/index";

import { ossUpload } from "@utils/filters/upload";

export default {
  data() {
    var checkDays = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("会员天数不能为空"));
      }
      setTimeout(() => {
        if (value <= 0) {
          callback(new Error("必须大于0"));
        } else {
          callback();
        }
      }, 500);
    };
    var checkLevel = (rule, value, callback) => {
      if (!value || value == "") {
        return callback(new Error("会员等级不能为空"));
      }
      setTimeout(() => {
        if (value <= 0) {
          callback(new Error("必须大于0"));
        } else {
          callback();
        }
      }, 500);
    };
    return {
      PAGE_SIZE,
      COMMON_STATUS,
      loading: false, //加载中--外层表格

      loading1: false, //加载中--icon
      loading2: false, //加载中--icon

      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      search: {},

      value1: "", //select2
      value2: true,

      dialogVisible: false, //弹出框显示隐藏
      innerVisible: false, //内层弹框
      clickType: "", //弹窗类型
      params: {}, //弹窗修改数据
      rules: {
        name: [
          { required: true, message: "请填写名称", trigger: "blur" },
          { max: 10, message: "不超过10个字符" },
        ],
        seq: [{ type: "number", message: "请填写数字", trigger: "blur" }],
      }, //表单验证提示

      tableData: [], //二级--组织列表
      srcList: [], //上传图片数组
      srcListBg: [], //背景图列表
      isMoer: true,
      isMoerBg: true, //背景图加号

      addShow: false,
      deleteShow: false,
      editShow: false,
      statusShow: true,
      searchShow: false,
    };
  },
  created() {
    this.getVipList();
    this.getPermissionButtonList()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false && this.params != {}) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
        this.srcList = [];
        this.srcListBg = [];
        this.isMoer = true;
        this.isMoerBg = true;
      }
    },
    innerVisible() {
      if (this.innerVisible == false) {
        this.innerChecked.code = [];
      }
    },
  },
  methods: {
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'guoxue:nav:query') {
            this.searchShow = true
          }
          if (item.code == 'guoxue:nav:add') {
            this.addShow = true
          }
          if (item.code == "guoxue:nav:delete") {
            this.deleteShow = true
          }
          if (item.code == "guoxue:nav:edit") {
            this.editShow = true
          }
          if (item.code == "guoxue:nav:status") {
            this.statusShow = false
          }
        })
      }
    },

    SearchEvaluationList() {
      this.page.pageNo = 1;
      this.getVipList();
    },
    /**
     *  table  //left menu  //search
     */
    async getVipList() {
      let http = "/intitle/nav/list";
      this.loading = true;
      const { data: resData } = await this.$get(http, {
        params: { ...this.search, ...this.page },
      });
      this.loading = false;
      if (!isEmpty(resData.data)) {
        this.tableData = resData.data;
      } else {
        this.tableData = [];
      }
      this.page.count = resData.page.count;
    },

    //switch状态改变 --接口
    handleSwitch(index) {
      this.$put(
        `/intitle/nav/info/status/${this.tableData[index].intitleNavId}`
      ).then((res) => {
        if (res.data.result == 200) {
          this.$message.success("操作成功");
        }
      });
    },
    //删除--会员等级
    // del(row) {
    //   this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
    //     type: "warning",
    //   }).then(async () => {
    //     const { data: resData } = await this.$delete(
    //       `/app/nav/info/${row.appNavId}`,
    //       {
    //         headers: {
    //           isLoading: true,
    //         },
    //       }
    //     );
    //     if (resData.result != 200) return;
    //     this.getVipList();
    //     this.$message.success("删除成功!");
    //   });
    // },

    // 弹窗
    handleClick(type, row = {}) {
      this.clickType = type;
      this.dialogVisible = true;

      if (type == "change") {
        //回显图片
        if (row.icon) {
          this.srcList = [];
          this.isMoer = false;
          this.srcList.push(row.icon);
        } else {
          this.srcList = [];
          this.isMoer = true;
        }
        if (row.bgimg) {
          this.srcListBg = [];
          this.isMoerBg = false;
          this.srcListBg.push(row.bgimg);
        } else {
          this.srcListBg = [];
          this.isMoerBg = true;
        }
        this.params = JSON.parse(JSON.stringify(row));
      } else {
        //添加
        this.params = {};
        this.params.color = "#409EFF";
      }
    },
    //窗口--提交 修改信息
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认提交修改, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          if (this.clickType == "addNext") {
            //修改
            if (!isEmpty(this.srcList)) {
              this.params.icon = JSON.parse(JSON.stringify(this.srcList[0]));
            }
            if (!isEmpty(this.srcListBg)) {
              this.params.bgimg = JSON.parse(JSON.stringify(this.srcListBg[0]));
            }
            const { data: resData } = await this.$post(
              "/intitle/nav/info",
              this.params,
              {
                headers: {
                  isLoading: true,
                },
              }
            );
            if (resData.result != 200) return;
            this.getVipList(); //重新获取数据
            this.dialogVisible = false; //弹窗隐藏
            this.$message.success("添加成功!");
          } else {
            if (this.clickType == "change") {
              //修改
              if (!isEmpty(this.srcList)) {
                this.params.icon = JSON.parse(JSON.stringify(this.srcList[0]));
              }
              if (!isEmpty(this.srcListBg)) {
                this.params.bgimg = JSON.parse(
                  JSON.stringify(this.srcListBg[0])
                );
              }
              const { data: resData } = await this.$put(
                "/intitle/nav/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
              );
              if (resData.result != 200) return;
              this.getVipList(); //重新获取数据
              this.dialogVisible = false; //弹窗隐藏
              this.$message.success("修改成功!");
            }
          }
        });
      });
    },

    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getVipList();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getVipList();
    },

    /**
     * 阿里云OSS签名
     */
    getPolicy() {
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },
    async getFile() {
      this.loading1 = true;
      const that = this;
      const { data: resData } = await this.$get("aliyun/oss/sign", {});
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
        that.$refs.file.files[0],
        resData.data,
        "one" //'more','one'
      );
      this.isMoer = false;
      this.loading1 = false;

      this.srcList = addRoutes;
      this.params.icon = this.srcList[0];
    },
    /* 多张图片上传 */
    getPolicyBg() {
      this.$refs.fileBg.dispatchEvent(new MouseEvent("click"));
    },
    async getfileBg() {
      this.loading2 = true;
      const that = this;
      const { data: resData } = await this.$get("aliyun/oss/sign", {});
      setTimeout(() => {
        this.loading2 = false;
      }, 1500);
      if (resData.result != 200) {
        return;
      }
      const addRoutes = await ossUpload(
        that.$refs.fileBg.files[0],
        resData.data,
        "one" //'more','one'
        // this.srcListBg
      );
      this.srcListBg = addRoutes;
      if (this.srcListBg.length >= 1) {
        this.isMoerBg = false;
      } else {
        this.isMoerBg = true;
      }
      this.params.bgimg = this.srcListBg;
    },
    removeUploading(index) {
      this.srcListBg.splice(index, 1);
      this.isMoerBg = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.role {
  display: flex;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;
  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;
    &_Top {
      display: flex;
      gap: 15px;
      overflow-x: hidden;
      .el-input {
        width: auto;
      }
    }
    &_Container {
      margin-top: 20px;

      .screenshot {
        position: relative;
      }
    }
    &_pagenation {
      margin: 40px auto;
    }
  }
}
::v-deep .el-table th,
::v-deep .el-table td {
  text-align: center !important;
}

.public-dialog-form {
  ::v-deep .el-color-picker__trigger {
    width: 60px;
    height: 60px;
  }
}
</style>
